import * as angular from 'angular';
import * as _ from 'underscore';

const waitingToaster = 'waiting';

export interface INotification {
    title?: string;
    body: string;
    toasterId?: string;
    timeout?: number;
}

export class NotificationService {
    public static $inject = ['toaster', '$translate'];

    private notificationTimeCoefficient = 1;

    constructor(private toaster: any, private $translate: angular.translate.ITranslateService) { }

    public clearAll() {
        this.toaster.clear(waitingToaster);
    }

    public showWaitingMessage(model?: INotification) {
        this.clearAll();
        if (this.isInvalidModel(model)) {
            model = {
                title: this.$translate.instant('please_wait'),
                body: this.$translate.instant('request_is_being_processed'),
                toasterId: waitingToaster
            };
        }

        this.showMessageInternal('wait', model);
    }

    public showSuccessMessage(model?: INotification | string) {
        if (this.isInvalidModel(model)) {
            model = {
                title: this.$translate.instant('success'),
                body: this.$translate.instant('your_changes_have_been_saved')
            };
        }

        this.showMessageInternal('success', model, 2000 * this.notificationTimeCoefficient);
    }

    public showErrorMessage(model?: INotification | string | Error) {
        if (this.isInvalidModel(model)) {
            model = {
                title: this.$translate.instant('internal_error'),
                body: this.$translate.instant('please_try_later')
            };
        }
        if (model instanceof Error) {
            const error = (model as Error);
            model = {
                title: error.name,
                body: error.message
            };
        }

        this.showMessageInternal('error', model, 15000 * this.notificationTimeCoefficient);
    }

    public showInfoMessage(model: INotification) {
        if (this.isInvalidModel(model)) {
            model = {
                title: this.$translate.instant('info'),
                body: this.$translate.instant('nothing_found')
            };
        }

        this.showMessageInternal('info', model, 3000 * this.notificationTimeCoefficient);
    }

    public setNotificationTimeCoefficient(value: number) {
        this.notificationTimeCoefficient = value;
    }

    private showMessageInternal(type: string, obj: INotification | any, defaultTimeOut?: number) {
        this.clearAll();

        if (obj) {
            if (typeof obj === 'string' || obj instanceof String) {
                obj = {
                    body: obj
                };
            }

            if (obj.timeout === undefined) {
                obj.timeout = defaultTimeOut;
            }

            this.toaster.pop({
                type,
                title: obj.title,
                body: obj.body,
                toasterId: obj.toasterId,
                timeout: obj.timeout || 0
            });
        }
    }

    private isInvalidModel(model: any) {
        return model == null || _.isUndefined(model) || _.isEmpty(model);
    }
}

angular.module('app.common').service('notificationService', NotificationService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/notification.service.ts